import { translate } from "../helpers/translate";
export var UserDocumentType;
(function (UserDocumentType) {
    UserDocumentType[UserDocumentType["Identity"] = 0] = "Identity";
    UserDocumentType[UserDocumentType["ProfilePicture"] = 1] = "ProfilePicture";
    UserDocumentType[UserDocumentType["COC"] = 2] = "COC";
    UserDocumentType[UserDocumentType["OtherDocuments"] = 3] = "OtherDocuments";
    UserDocumentType[UserDocumentType["ClientContract"] = 4] = "ClientContract";
})(UserDocumentType || (UserDocumentType = {}));
export const UserDocumentTypeMap = new Map([
    [UserDocumentType.Identity, translate('enums.UserDocumentType.pending')],
    [UserDocumentType.ProfilePicture, translate('enums.UserDocumentType.approved')],
    [UserDocumentType.COC, translate('enums.UserDocumentType.disapproved')],
    [UserDocumentType.OtherDocuments, translate('enums.UserDocumentType.pendingKyc')],
    [UserDocumentType.ClientContract, translate('enums.UserDocumentType.pendingKyc')]
]);
